import classNames from 'classnames';

import { AvatarXLarge } from '../Avatar/Avatar';

import css from './ProfileHeading.module.css';

const ProfileHeading = ({ user, className, rootClassName }) => {
  const { bio, displayName } = user?.attributes?.profile || {};

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      <AvatarXLarge className={css.avatar} user={user} disableProfileLink />
      <h1 className={css.name}>{displayName}</h1>
      {bio && <div className={css.bio}>{bio}</div>}
    </div>
  );
};

export default ProfileHeading;
